import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import { Users, Video } from "lucide-react";

export default function Register() {
  const { t } = useI18n();
  return (
    <div className="max-w-5xl mx-auto px-6 py-16 lg:py-24">
      <div className="font-mono text-[11px] uppercase tracking-widest text-[#2DD4A7] mb-3">{t("auth.registerEyebrow")}</div>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mb-10">{t("nav.register")}</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Link to="/register/player" data-testid="choose-player" className="group border border-white/15 p-8 lg:p-10 hover:border-[#2DD4A7] transition-colors">
          <Users className="w-8 h-8 mb-6 text-[#2DD4A7]" strokeWidth={2} />
          <div className="font-display text-2xl font-bold mb-3">{t("nav.playerRegister")}</div>
          <p className="text-sm text-[#8B97AE] leading-relaxed">{t("auth.playerCardDesc")}</p>
        </Link>
        <Link to="/register/streamer" data-testid="choose-streamer" className="group border border-white/15 p-8 lg:p-10 hover:border-[#2DD4A7] transition-colors">
          <Video className="w-8 h-8 mb-6 text-[#2DD4A7]" strokeWidth={2} />
          <div className="font-display text-2xl font-bold mb-3">{t("nav.streamerRegister")}</div>
          <p className="text-sm text-[#8B97AE] leading-relaxed">{t("auth.streamerCardDesc")}</p>
        </Link>
      </div>
    </div>
  );
}
